import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { HashRouter, Routes, Route } from "react-router-dom";
import { initializeIcons } from "@fluentui/react";
import { Provider } from "react-redux";
import "./i18n/config";

import "./index.css";

import Header from "./pages/header/Header";
import NoPage from "./pages/NoPage";
import Layout from "./pages/layout/Layout";

import store from "./store";

initializeIcons();

export default function App() {
    useEffect(()=>{
        if(typeof window?.MathJax !== "undefined"){
          window.MathJax.typeset()
        }
      },[])
    return (
        <HashRouter>
            <Routes>
                <Route path="/" element={<Header />}>
                    <Route index element={<Layout />} />
                    <Route path="dev_mode" element={<Layout />} />
                    <Route path="*" element={<NoPage />} />
                </Route>
            </Routes>
        </HashRouter>
    );
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>
);
